/* eslint-disable react/prefer-es6-class, react/sort-comp, react/prop-types, react/no-multi-comp, no-unused-vars */
import classnames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import includes from 'lodash/includes';
import Keys, { KeyHelpers } from 'es6/core/keys';
import SoundManager from 'es6/services/sound-manager';
import { CLICK } from 'es6/core/sound-effects';

const ALIGN_STATES = ['left', 'center', 'right'];

/**
 * Detects if an element is a navigation button
 *
 * @param {HTMLElement} el
 */
function isNavButton(el) {
  return el && el.dataset && el.dataset.navButton;
}

export const NavContainer = React.createClass({
  display: 'NavContainer',

  propTypes: {
    align: React.PropTypes.oneOf(ALIGN_STATES),
    className: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      align: 'left',
      className: '',
    };
  },

  render() {
    const className = classnames('nav-container', this.props.className);
    return (
      <div className={className}>{this.props.children}</div>
    );
  },
});

export const NavButton = React.createClass({
  displayName: 'NavButton',

  propTypes: {
    align: React.PropTypes.oneOf(ALIGN_STATES),
    className: React.PropTypes.string,
    keyCode: React.PropTypes.oneOf(_.values(Keys)),
    focusable: React.PropTypes.bool,
    focused: React.PropTypes.bool,
    onClick: React.PropTypes.func,
    title: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      align: 'left',
      className: '',
      focusable: true,
      focused: false,
      title: '',
    };
  },

  componentDidMount() {
    window.addEventListener('keydown', this._handleKeydown);
    window.addEventListener('keyup', this._handleKeyup);
  },

  componentDidUpdate(prevProps, prevState) {
    // Make sure the button doesn't have focus if it becomes unfocusable.
    if (!this.props.focusable) {
      ReactDOM.findDOMNode(this).blur();
    }
  },

  componentWillUnmount() {
    window.removeEventListener('keydown', this._handleKeydown);
    window.removeEventListener('keyup', this._handleKeyup);
  },

  /**
   * Helper method for _handleKeydown and _handlKeyup. If the keyCode
   * is set to the enter key, then check to make sure that nothing else
   * that has an enter event is focused.
   *
   * Keep in mind that if the user hits enter, we can still return false
   * here and let the browsers natural enter event bubble up.
   */
  _canUseEnter() {
    if (this.props.keyCode !== Keys.ENTER) {
      return true;
    }

    const focusableElements = ['A', 'BUTTON', 'INPUT', 'SELECT', 'TEXTAREA'];
    return !document.activeElement || focusableElements.indexOf(document.activeElement.tagName) === -1;
  },

  _handleKeydown(e) {
    const keyCode = this.props.keyCode;

    // Don't trigger button on space.
    if (e.keyCode === Keys.SPACE && keyCode !== Keys.SPACE) {
      e.preventDefault();
    }

    // Focus button on key down.
    if (keyCode && e.keyCode === keyCode && this._canUseEnter()) {
      ReactDOM.findDOMNode(this).focus();
    }
  },

  _handleKeyup(e) {
    const keyCode = this.props.keyCode;

    // Don't trigger button on space.
    if (e.keyCode === Keys.SPACE && keyCode !== Keys.SPACE) {
      e.preventDefault();
    }

    // Trigger action on key up.
    if (keyCode && e.keyCode === keyCode && this._canUseEnter()) {
      this._onClick(e);
    }
  },

  _onClick(e) {
    if (this.props.disabled) {
      return;
    }

    // The last argument enableds preventStopSounds so that the click sound effect does not stop
    // other playing sounds.
    SoundManager.playEffect(CLICK, {}, true);

    if (this.props.onClick) {
      this.props.onClick(e);
    }
  },

  render() {
    const { children, disabled, focusable, focused, onClick, title } = this.props;
    const className = classnames(
      `btn btn-bar btn-nav btn-${this.props.align}`,
      { disabled },
      this.props.className
    );

    const props = {
      className,
      'data-nav-button': true,
      'data-focusable': focusable ? 'data-focusable' : null,
      'data-default-focused': focused ? 'data-default-focused' : null,
      onClick: this._onClick,
      title,
    };

    return (
      <button {...props}>{children}</button>
    );
  },
});

export const Navigation = React.createClass({
  displayName: 'Navigation',

  propTypes: {
    disableEnterKey: React.PropTypes.bool,
    disableArrowKeys: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      disableEnterKey: false,
      disableArrowKeys: false,
    };
  },

  componentDidMount() {
    window.addEventListener('keydown', this._handleKeydown);

    this.focusDefaultButton();
  },

  componentWillUnmount() {
    window.removeEventListener('keydown', this._handleKeydown);
  },

  _getFocusedButton() {
    return ReactDOM.findDOMNode(this).querySelector('.btn[data-focusable]:focus');
  },

  _getFocusableButtons() {
    return ReactDOM.findDOMNode(this).querySelectorAll('.btn[data-focusable]');
  },

  _handleKeydown(e) {
    const { keyCode } = e;
    const { disableEnterKey, disableArrowKeys } = this.props;

    if (disableEnterKey) {
      // Prevent default behavior on the enter key so the user can't click the button using enter.
      if (keyCode === Keys.ENTER && isNavButton(document.activeElement)) {
        e.preventDefault();
      }
    }

    if (!disableArrowKeys && (KeyHelpers.isLeft(keyCode) || KeyHelpers.isRight(keyCode))) {
      const focusableButtons = this._getFocusableButtons();

      if (focusableButtons.length === 0) {
        return;
      }

      // Get focused button.
      const focusedButton = this._getFocusedButton();

      // querySelectorAll returns NodeList instead of Array.
      let focusedIndex = Array.prototype.indexOf.call(focusableButtons, focusedButton);

      if (focusedIndex === -1) {
        focusedIndex = focusableButtons.length - 1;
      } else if (KeyHelpers.isLeft(keyCode) && focusedIndex > 0) {
        focusedIndex -= 1;
      } else if (KeyHelpers.isRight(keyCode) && focusedIndex < focusableButtons.length - 1) {
        focusedIndex += 1;
      }

      focusableButtons[focusedIndex].focus();
    }
  },

  render() {
    const children = this.props.children instanceof Array ? this.props.children : [this.props.children];

    // Reorder children to go from left to right.
    const leftChildren = children.filter(child => child.props.align === 'left');
    const rightChildren = children.filter(child => child.props.align === 'right');

    // Default everything else to the center.
    const centerChildren = children.filter(child => !includes(['left', 'right'], child.props.align));

    return (
      <section className="screen-navigation">
        <div className="screen-navigation-left">{leftChildren}</div>
        <div className="screen-navigation-center">{centerChildren}</div>
        <div className="screen-navigation-right">{rightChildren}</div>
      </section>
    );
  },

  /**
   * Focus the default NavButton (the NavButton with the focused prop set to true) if another
   * NavButton isn't already focused.
   *
   * @param {boolean} forceDefault if true, refocuses the default button even if another button is
   * currently focused.
   */
  focusDefaultButton(forceDefault) {
    // Don't focus the default button if another nav button is already focused.
    if (forceDefault !== true && this._getFocusedButton()) {
      return;
    }

    const defaultButton = ReactDOM.findDOMNode(this).querySelector('.btn[data-default-focused]');
    if (defaultButton) {
      defaultButton.focus();
    }
  },
});
